<template>
  <div id="app">
    <div class="flex flex-col bg-gray-200 content-center items-center p-5">
      <h1 class="font-mono text-xl">Bus Stop : {{ busStop }}</h1>
      <form @submit="setNewStop($event)">
        <input
          class="bg-white max-w-md focus:outline-none focus:shadow-outline border border-gray-300 rounded-lg py-2 px-4 block w-full appearance-none leading-normal"
          type="text"
          id="busStopNumber"
          placeholder="Bus Stop Number"
        />
      </form>

      <Entry
        v-for="bus in busData"
        :serviceno="bus.ServiceNo"
        :time="bus.TimeToArrive"
        :load="bus.Load"
        :type="bus.Type"
        :key="bus.id"
      />
    </div>
  </div>
</template>

<script>
import Entry from "./components/Entry";
import updateSchedule from "./UpdateData";

export default {
  name: "App",
  components: {
    Entry
  },
  data: function() {
    return {
      busStop: "",
      busData: []
    };
  },
  methods: {
    setNewStop: function(event) {
      console.log(event.target.elements.busStopNumber.value);
      console.log(window.location.origin);

      window.location.href =
        window.location.origin +
        "?busStop=" +
        event.target.elements.busStopNumber.value;
      event.preventDefault();
    },
    updateData: function() {
      var vm = this;

      setInterval(function() {
        updateSchedule(vm.busStop).then(data => {
          data.sort((a, b) => {
            return a.Time - b.Time;
          });
          vm.busData = data;
          console.log(data);
        });
      }, 30000);
    }
  },
  created() {
    // set the bus stop when we first load.
    var url = new URL(window.location.href);
    this.busStop = url.searchParams.get("busStop");
    // if this the index page with no search terms, default to 09037
    if (this.busStop === null) {
      this.busStop = "09037";
    }

    // immediately update the buses that are coming in.

    updateSchedule(this.busStop).then(data => {
      data.sort((a, b) => {
        return a.Time - b.Time;
      });
      this.busData = data;
      //console.log(data);
    });

    // set up an update interval
    this.updateData();
  }
};
</script>

<style>
#app {
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
</style>
